import React from "react";

// MUI
import Box from "@mui/material/Box";
import MuiDialog from "@mui/material/Dialog";
import Stack from "@mui/material/Stack";
import MuiIconButton from "@mui/material/IconButton";

// Components
import Typography from "./Typography";

// Icons
import CloseIcon from "@mui/icons-material/CloseOutlined";

const Dialog = ({
    open,
    handleClose,
    title,
    children,
    maxWidth = "sm",
    titleVariant = "h4",
    sx,
    ...rest
}) => {
    return (
        <MuiDialog
            open={open}
            onClose={handleClose}
            maxWidth={maxWidth}
            fullWidth={true}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            sx={{
                ".MuiPaper-root": {
                    margin: "0 !important",
                    width: "auto",
                },
                ...sx,
            }}
            {...rest}
        >
            <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                sx={{
                    px: 3,
                    pt: 3,
                }}
            >
                <Typography variant={titleVariant} noMargin>
                    {title}
                </Typography>
                <MuiIconButton onClick={handleClose}>
                    <CloseIcon color="primary" />
                </MuiIconButton>
            </Stack>
            <Box sx={{ p: 3 }}>{children}</Box>
        </MuiDialog>
    );
};

export default Dialog;
